// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { ProductModel } from "@insite/client-framework/Types/ApiModels";
import {
    getProductByErp,
    GetProductByErpParameter,
    GetProductByErpResult,
} from "@stoneage/App/Services/JettingApp/JettingAppService";

type Parameter = GetProductByErpParameter & HasOnSuccess<ProductModel>;

type Props = {
    apiParameter: { productNumbers: string[] };
    apiResult: GetProductByErpResult;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = {
        ...props.parameter,
    };
};

export const DispatchBeginLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "xJettingAppCalculators/isProductLoading" as any,
    });
};

export const RequestDataFromProductsApi: HandlerType = async props => {
    props.apiResult = await getProductByErp({
        productNumbers: props.parameter.productNumbers,
    } as any);
};

export const DispatchCompleteLoadProducts: HandlerType = props => {
    props.dispatch({
        type: "xJettingAppCalculators/CompleteLoadProduct",
        product: props.apiResult.products?.[0],
    } as any);
};

export const chain = [
    PopulateApiParameter,
    DispatchBeginLoadProducts,
    RequestDataFromProductsApi,
    DispatchCompleteLoadProducts,
];

const jettingAppLoadProduct = createHandlerChainRunner(chain, "JettingAppLoadProduct");
export default jettingAppLoadProduct;
